import React from "react";

const Iframe = () => {
	return (
		<iframe
			src='https://www.google.com/maps?q=Machhapokhari,+Kathmandu,+Nepal&output=embed'
			title='Map of Machhapokhari, Kathmandu'
			width='100%'
			height='450'
			style={{ border: 0 }}
			allowFullScreen=''
			loading='lazy'
			referrerPolicy='no-referrer-when-downgrade'></iframe>
	);
};

export default Iframe;
